import React, { Component } from 'react';
//import logo from './logo.svg';
import './App.css';

import Board from './Board';
import History from './History.js';

class App extends Component {
  render() {
    return (
      <div className="App">
      <History
        onRef={ref => (this.history = ref)}
        />
      <Board history={{
        addStep: (step) => this.history.addStep(step),
        undo: () => this.history.undo(),
        getUndoState: () => this.history.getUndoState(),
        redo: () => this.history.redo(),
        getRedoState: () => this.history.getRedoState(),
      }} location={this.props.location} />
      </div>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js